// External API Configuration
export const EXTERNAL_API_CONFIG = {
  // Base URL for external API (webhook)
  // In development, use CORS proxy to bypass CORS restrictions
  BASE_URL: (() => {
    // Check if user has set a custom URL
    if (process.env.REACT_APP_EXTERNAL_API_URL) {
      console.log('🔧 Using custom webhook URL from environment');
      return process.env.REACT_APP_EXTERNAL_API_URL;
    }
    
    // Auto-detect environment and apply CORS proxy for development
    if (process.env.NODE_ENV === 'development') {
      console.log('🔧 Development mode detected - using CORS proxy');
      return 'https://cors-anywhere.herokuapp.com/https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f';
    } else {
      console.log('🔧 Production mode detected - using direct webhook');
      return 'https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f';
    }
  })(),
  
  // Endpoints - using complete webhook URLs
  ENDPOINTS: {
    UPLOAD_DOCUMENT: '', // Empty string since BASE_URL is the complete endpoint
    HEALTH_CHECK: '', // Empty string since BASE_URL is the complete endpoint
  },
  
  // Default timeout in milliseconds
  TIMEOUT: 10000, // 35 seconds (30s + 5s buffer)
  
  // Retry configuration
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },
  
  // File size limits (in bytes) - Increased for high-quality OCR
  LIMITS: {
    MAX_PDF_SIZE: 25 * 1024 * 1024, // 25MB - Increased for high-quality OCR PDFs
    MAX_PHOTO_SIZE: 15 * 1024 * 1024, // 15MB - Increased for high-quality photos
  },
  
  // Webhook specific configuration
  WEBHOOK: {
    METHOD: 'POST',
    CONTENT_TYPE: 'application/json',
    RESPONSE_TIMEOUT: 90000, // 90 seconds for webhook response
    AUTH_TYPE: 'basic',
    // Default credentials from environment variables
    USERNAME: process.env.REACT_APP_WEBHOOK_USERNAME || 'default_user',
    PASSWORD: process.env.REACT_APP_WEBHOOK_PASSWORD || 'default_password',
  },
};

// Log configuration for debugging
console.log('🔧 External API Config:', {
  NODE_ENV: process.env.NODE_ENV,
  NODE_ENV_TYPE: typeof process.env.NODE_ENV,
  BASE_URL: process.env.REACT_APP_EXTERNAL_API_URL || 
    (process.env.NODE_ENV === 'development' 
      ? 'https://cors-anywhere.herokuapp.com/https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f'
      : 'https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f'),
  USERNAME: process.env.REACT_APP_WEBHOOK_USERNAME || 'default_user',
  PASSWORD: process.env.REACT_APP_WEBHOOK_PASSWORD ? '***SET***' : '***NOT SET***',
  ENDPOINTS: {
    UPLOAD_DOCUMENT: '',
    HEALTH_CHECK: ''
  }
});

// Force CORS proxy for development (fallback)
if (!process.env.REACT_APP_EXTERNAL_API_URL && process.env.NODE_ENV !== 'production') {
  console.log('🔧 Forcing CORS proxy for development environment');
  EXTERNAL_API_CONFIG.BASE_URL = 'https://cors-anywhere.herokuapp.com/https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f';
}

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  // If endpoint is empty, return BASE_URL directly (for complete webhook URLs)
  if (!endpoint) {
    let url = EXTERNAL_API_CONFIG.BASE_URL;
    
    // Force CORS proxy if not already present and in development
    if (!url.includes('cors-anywhere.herokuapp.com') && process.env.NODE_ENV !== 'production') {
      console.log('🔧 Forcing CORS proxy in getApiUrl');
      url = 'https://cors-anywhere.herokuapp.com/https://n8n.invoicefactory.eu/webhook/ae8f7e97-e89a-4ad3-8f68-130d4941669f';
    }
    
    console.log('🌐 Using webhook URL:', url);
    console.log('🔍 CORS proxy active:', url.includes('cors-anywhere.herokuapp.com'));
    return url;
  }
  return `${EXTERNAL_API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to check if API is configured
export const isApiConfigured = (): boolean => {
  return EXTERNAL_API_CONFIG.BASE_URL !== 'https://api.example.com';
};

// Helper function to get CORS proxy URL
export const getCorsProxyUrl = (targetUrl: string): string => {
  return `https://cors-anywhere.herokuapp.com/${targetUrl}`;
};

// Helper function to check if CORS proxy is active
export const isCorsProxyActive = (): boolean => {
  return EXTERNAL_API_CONFIG.BASE_URL.includes('cors-anywhere.herokuapp.com');
};
